import { PreviewStatus } from "@/types/coupon-wall";

// 默认头图背景
export const DEFAULT_BG_IMG = "https://p0.meituan.net/pepperfe/a71dccbeace81ae317b447437e43eed1247625.png";
// 红包墙按钮样式
export const COUPON_WALL_STYLE = {
  // 红包墙静态占位图配置
  couponWallPreviewImageConfig: {
    [PreviewStatus.LOADING]: 'https://p0.meituan.net/pepperfe/66d6de141fe0412b69576637ba1c1f53234625.png',
    [PreviewStatus.RECEIVING]: 'https://p0.meituan.net/pepperfe/66d6de141fe0412b69576637ba1c1f53234625.png',
    [PreviewStatus.NOT_LOGIN]: 'https://p0.meituan.net/pepperfe/66d6de141fe0412b69576637ba1c1f53234625.png',
  },
  // 红包墙底部图片
  couponWallBottomBgUrl: "https://p0.meituan.net/pepperfe/4683e202963daa2391a71300e51daef067099.png",
};

// 头图高度
export const BANNER_HEIGHT = 270;
// 券快筛图标
export const COUPON_SELECTION_ICON = "https://p1.meituan.net/pepperfe/fc7082b16d7779440443a7e21d0c04e45285.png";
// 资源位请求入参
export const RESOURCE_SCENE = 4;
// Tabbar 请求入参
export const SEARCH_RULE_SCENE = 20;
export const DEFAULT_BIZ_SCENE = 57;
// 页面不限制开放城市
export const OPEN_CITY_ID_LIST: number[] | undefined = undefined;
export const UNAVAILABLE_IMG = "https://p0.meituan.net/pepperfe/f6e2c66fbbdca69cf308f753a2bc17c574361.png";